var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgVisa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.125,
    height: 15.127,
    viewBox: "0 0 49.125 15.127",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "img-visa",
    transform: "translate(-407 -349.661)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_747",
    "data-name": "Path 747",
    d: "M422.035,349.845,419.543,364.5h3.99l2.5-14.651Zm0,0",
    transform: "translate(4.633 0.068)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_748",
    "data-name": "Path 748",
    d: "M419.757,349.856l-3.911,9.992-.416-1.508a15.74,15.74,0,0,0-5.532-6.072l3.574,12.217,4.226-.005,6.291-14.625Zm0,0",
    transform: "translate(1.07 0.072)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_749",
    "data-name": "Path 749",
    d: "M414.981,350.948a1.6,1.6,0,0,0-1.738-1.193h-6.189l-.053.294c4.82,1.165,8.008,3.979,9.328,7.366Zm0,0",
    transform: "translate(0 0.035)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_750",
    "data-name": "Path 750",
    d: "M432.374,352.726a7.423,7.423,0,0,1,2.991.557l.359.171.54-3.178a10.343,10.343,0,0,0-3.573-.615c-3.948,0-6.729,1.99-6.751,4.835-.026,2.107,1.98,3.28,3.5,3.981,1.557.722,2.075,1.176,2.07,1.818-.016.983-1.242,1.434-2.392,1.434a8.345,8.345,0,0,1-3.76-.771l-.514-.23-.561,3.28a12.811,12.811,0,0,0,4.45.781c4.2,0,6.927-1.969,6.954-5.006.016-1.669-1.048-2.937-3.354-3.981-1.4-.679-2.251-1.134-2.246-1.818,0-.609.727-1.257,2.288-1.257Zm0,0",
    transform: "translate(6.383)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_751",
    "data-name": "Path 751",
    d: "M443.511,349.856h-3.086a1.989,1.989,0,0,0-2.092,1.22L432.406,364.5H436.6s.685-1.809.839-2.2l5.113.005c.118.508.487,2.194.487,2.194h3.7Zm-4.927,9.447c.331-.839,1.594-4.1,1.594-4.1-.022.042.326-.846.53-1.4l.272,1.263.926,4.231Zm0,0",
    transform: "translate(9.383 0.072)",
    fill: "#505050"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgVisa);
export default __webpack_public_path__ + "static/media/img-visa.5b1d9af9adb9cca39248b7cdcbb8f941.svg";
export { ForwardRef as ReactComponent };